import "./ServiceRequestModal.scss"

import { CCol, CModal, CModalBody, CRow } from "@coreui/react"
import DeloitteOcLogo from "assets/icons/brand/Deloitte_oc_Logo.svg"
import cross from "assets/icons/Cross.svg"
import Info from "assets/icons/info.svg"
import CMSTabs from "components/common/button/CMSTabs"
import { Tooltip } from "components/common/tooltip"
import { isClient, isCmsUser } from "constants/Constants"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useSelector } from "react-redux"

import ServiceRequestConstants from "./ServiceRequestConstants"

const ServiceRequestSection = ({ sectionData }) => {
  return (
    <CCol className="request-services-container">
      {sectionData.map((item, index) => {
        return (
          <div key={index} className="pb-3">
            {/* Render key */}
            <CRow className="request-service-key mb-2">
              <a target="_blank" href={item.key.link} rel="noreferrer">
                {item.key.text}
              </a>
              <Tooltip text={item.key.hoverText}>
                <img
                  src={Info}
                  alt="info"
                  className={`tooltip-info-icon ml-2${item.key.hoverText ? "" : " disabled"
                    }`}
                />
              </Tooltip>
            </CRow>
            {/* Render value */}
            {item.value && item.value.length > 0 && (
              <CRow className="request-service-value d-flex">
                {item.value.map((valueItem, valueIndex) => (
                  <div
                    className="services-value-container p-2"
                    key={valueIndex}
                  >
                    <div className="services-value-element d-flex">
                      <a
                        target="_blank"
                        href={valueItem.link}
                        className="mr-1"
                        rel="noreferrer"
                      >
                        {valueItem.text}
                      </a>
                      <Tooltip text={valueItem.hoverText} zIndex={1000}>
                        <img
                          src={Info}
                          alt="info"
                          className={`tooltip-info-icon ml-2${valueItem.hoverText ? "" : " disabled"
                            }`}
                        />
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </CRow>
            )}
          </div>
        )
      })}
    </CCol>
  )
}

export default function ServiceRequestModal({ show, setShow }) {
  const userRole = useSelector((state) => {
    return state.user.role
  })

  const serviceCategories = [
    "Cloud Infrastructure",
    "Network Services",
    "Security",
    "Okta User Access",
    "Cloud Economics",
    "BizOps Services",
    "AWS Support",
    "AI / ML Service Request",
    "Global Cloud Operations Services",
    "HCMS Operations Management"
  ]
  const [selectedServiceTab, setSelectedServiceTab] = useState(
    serviceCategories[0]
  )

  const serviceModalTabContent = ServiceRequestConstants()

  const closeModal = () => {
    setShow(false)
  }
  return (
    <CModal show={show} size="xl" onClose={closeModal}>
      <img
        src={cross}
        alt="cross"
        className="req-modal-close"
        width="17"
        height="17"
        tabIndex={0}
        onClick={closeModal}
      />
      <CModalBody className="service-request-modal-container">
        <div className="create-incident-header d-flex pl-3 pr-3">
          <img
            className="p-1"
            src={DeloitteOcLogo}
            alt={"deloitte-logo-short"}
          />
          <a
            className="create-incident-link flex-center mt-4 mb-4 p-2"
            target="_blank"
            href="https://deloittecloud.service-now.com/Portal?id=sc_cat_item&sys_id=3f1dd0320a0a0b99000a53f7604a2ef9"
            rel="noreferrer"
          >
            Create an Incident record
          </a>
        </div>
        <div className="service-request-divider mt-4 mb-2">Request Service</div>
        <div className="p-0">
          <CMSTabs
            tabs={serviceCategories
              .filter((category) => {
                if (
                  category === "Security" ||
                  category === "Cloud Economics" ||
                  category === "AI / ML Service Request"
                ) {
                  return !isClient(userRole)
                } else if (category === "BizOps Services") {
                  return isCmsUser(userRole)
                } else if (category === "AWS Support") {
                  return [
                    "Portal-Admin",
                    "Portal-User",
                    "Non-CMS-User-ITIL",
                    "Non-CMS-User"
                  ].includes(userRole)
                }
                return true
              })
              .map((category) => ({
                text: category,
                key: category
              }))}
            selectedTab={selectedServiceTab}
            onChange={setSelectedServiceTab}
            isPopupTab={true}
          />
        </div>
        {selectedServiceTab === serviceCategories[0] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.cloudInfra}
          />
        )}
        {selectedServiceTab === serviceCategories[1] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.networkServices}
          />
        )}
        {selectedServiceTab === serviceCategories[2] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.security}
          />
        )}
        {selectedServiceTab === serviceCategories[3] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.oktaUsrAccessMgmt}
          />
        )}
        {selectedServiceTab === serviceCategories[4] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.cloudEconomics}
          />
        )}
        {selectedServiceTab === serviceCategories[5] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.businessOpServices}
          />
        )}
        {selectedServiceTab === serviceCategories[6] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.awsServices}
          />
        )}
        {selectedServiceTab === serviceCategories[7] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.aiMLServices}
          />
        )}
        {selectedServiceTab === serviceCategories[8] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.globalCloudOpServices}
          />
        )}
        {selectedServiceTab === serviceCategories[9] && (
          <ServiceRequestSection
            sectionData={serviceModalTabContent.hcmsOpsMgmt}
          />
        )}
      </CModalBody>
    </CModal>
  )
}

ServiceRequestModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func
}
